import { render, staticRenderFns } from "./AdmissionLetter.vue?vue&type=template&id=679b2f50&"
import script from "./AdmissionLetter.vue?vue&type=script&lang=js&"
export * from "./AdmissionLetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports